import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@mybridge/ui';
import { forwardRef, useContext, useState } from 'react';
import { DiskContext } from '../context';
import { useForm } from 'react-hook-form';
import { DiskDirectoryTree } from '../directory-tree';
import { getFullFileName } from 'v4/lib/commons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
export const DiskCopyModal = forwardRef(({ ...props }, ref) => {
  const [selected, setSelected] = useState();
  const { copyFileFolder, selectedFile, copyDisc, copyFileFolderLoading } =
    useContext(DiskContext);
  const { t } = useTranslator();
  const direction = useDirection();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = () => {
    copyFileFolder({ file: selectedFile, parent: selected?.id, team_id:selected?.team_info?.id });
  };
  return (
    <>
      <Modal size="2xl" {...copyDisc}>
        <ModalOverlay />
        <ModalContent>
          <form onSubmit={handleSubmit(onSubmit)}>
            <ModalCloseButton {...(direction === 'rtl') ? {left: '0.75rem', right: 'auto'} : {left: 'auto', right: '0.75rem'}} />
            <ModalHeader>
              <Text truncate maxW="80">
                {t('myDisk.copy') || "Copy"} "{getFullFileName(selectedFile)}" {t('otherModules.here_to') || "here to"}...
              </Text>
            </ModalHeader>
            <ModalBody maxH="70vh" overflowY="auto">
              <DiskDirectoryTree setSelectedItem={setSelected} />
            </ModalBody>
            <ModalFooter>
              <Button
                borderRadius="30px"
                isLoading={copyFileFolderLoading}
                type="submit"
                variant="primary"
              >
                {t('myDisk.copy') || "Copy"}
              </Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </>
  );
});
